export default "__VITE_ASSET__DPTzqAq3__"